import React from "react";
import message from "../../Images/message-text.png";
import client1 from "../../Images/client-1.png";
import client2 from "../../Images/client-2.png";
import client3 from "../../Images/client-3.png";
import client4 from "../../Images/client-4.png";
import client5 from "../../Images/client-5.png";
import client6 from "../../Images/client-6.png";
import client7 from "../../Images/client-7.png";
import client8 from "../../Images/client-8.png";
import quote from "../../Images/qute.png";

const ReviewComponent2 = () => {
  return (
    <section
      className="troo-da-clients-reviews-section padding-top padding-bottom"
      id="troo-da-clients-reviews-section"
    >
      <div className="client-cricle"></div>
      <figure className="chat-icon">
        <img src={message} alt="message" />
      </figure>
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <div className="client-section">
              <h4>"Wow what great service, I love it!"</h4>
              <p>
                Contrary to popular belief, Lorem Ipsum is not simply random
                text. It has roots in a piece of classical an Latin literature
                from 45 BC, making it over 2000 years old. Richard McClintock.
              </p>
              <div className="client-img">
                <div className="img-col">
                  <img src={client1} alt="client" />
                </div>
                <div className="client-deatils">
                  <strong>Naomi Karla</strong>
                  <p>Executive Chairman</p>
                </div>
              </div>
              <div className="clint-qute">
                <span>”</span>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="client-section">
              <h4>"Affirm is the real deal! It's really wonderful."</h4>
              <p>
                Contrary to popular belief, Lorem Ipsum is not simply random
                text. It has roots in a piece of classical an Latin literature
                from 45 BC, making it over 2000 years old. Richard McClintock.
              </p>
              <div className="client-img">
                <div className="img-col">
                  <img src={client2} alt="cl2" />
                </div>
                <div className="client-deatils">
                  <strong>Jason Cole</strong>
                  <p>SEO Expert</p>
                </div>
              </div>
              <div className="clint-qute">
                <span>”</span>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="client-section">
              <h4>"I will refer everyone I know."</h4>
              <p>
                Contrary to popular belief, Lorem Ipsum is not simply random
                text. It has roots in a piece of classical an Latin literature
                from 45 BC, making it over 2000 years old. Richard McClintock.
              </p>
              <div className="client-img">
                <div className="img-col">
                  <img src={client3} alt="client3" />
                </div>
                <div className="client-deatils">
                  <strong>Alexa anderson</strong>
                  <p>Executive Chairman</p>
                </div>
              </div>
              <div className="clint-qute">
                <span>”</span>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="client-section">
              <h4>"It's really wonderful."</h4>
              <p>
                Contrary to popular belief, Lorem Ipsum is not simply random
                text. It has roots in a piece of classical an Latin literature
                from 45 BC, making it over 2000 years old. Richard McClintock.
              </p>
              <div className="client-img">
                <div className="img-col">
                  <img src={client4} alt="client4" />
                </div>
                <div className="client-deatils">
                  <strong>Adam Cena</strong>
                  <p>SEO Expert</p>
                </div>
              </div>
              <div className="clint-qute">
                <span>”</span>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6">
            <div className="client-section">
              <h4>"I will refer everyone I know."</h4>
              <p>
                Contrary to popular belief, Lorem Ipsum is not simply random
                text. It has roots in a piece of classical an Latin literature
                from 45 BC, making it over 2000 years old. Richard McClintock.
              </p>
              <div className="client-img">
                <div className="img-col">
                  <img src={client5} alt="cl5" />
                </div>
                <div className="client-deatils">
                  <strong>Victor Aldves</strong>
                  <p>Professor</p>
                </div>
              </div>
              <div className="clint-qute">
                <span>”</span>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="client-section">
              <h4>"It's really wonderful."</h4>
              <p>
                Contrary to popular belief, Lorem Ipsum is not simply random
                text. It has roots in a piece of classical an Latin literature
                from 45 BC, making it over 2000 years old. Richard McClintock.
              </p>
              <div className="client-img">
                <div className="img-col">
                  <img src={client6} alt="client6" />
                </div>
                <div className="client-deatils">
                  <strong>Brenden White</strong>
                  <p>Assistant Director</p>
                </div>
              </div>
              <div className="clint-qute">
                <span>”</span>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6">
            <div className="client-section">
              <h4>"I will refer everyone I know."</h4>
              <p>
                Contrary to popular belief, Lorem Ipsum is not simply random
                text. It has roots in a piece of classical an Latin literature
                from 45 BC, making it over 2000 years old. Richard McClintock.
              </p>
              <div className="client-img">
                <div className="img-col">
                  <img src={client7} alt="cle7" />
                </div>
                <div className="client-deatils">
                  <strong>Johan Smith</strong>
                  <p>Manager</p>
                </div>
              </div>
              <div className="clint-qute">
                <span>”</span>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="client-section">
              <h4>"It's really wonderful."</h4>
              <p>
                Contrary to popular belief, Lorem Ipsum is not simply random
                text. It has roots in a piece of classical an Latin literature
                from 45 BC, making it over 2000 years old. Richard McClintock.
              </p>
              <div className="client-img">
                <div className="img-col">
                  <img src={client8} alt="cl8" />
                </div>
                <div className="client-deatils">
                  <strong>Naomi Nelis</strong>
                  <p>Chief Executive</p>
                </div>
              </div>
              <div className="clint-qute">
                <span>”</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="qute-icon">
        <img src={quote} alt="quote" />
      </div>
    </section>
  );
};

export default ReviewComponent2;
